/**
 * The reviewer name a public page may print. Counsel ruling 2026-10-23:
 * no full client names on public pages. Show first name plus last initial,
 * or initials when Google itself shows only initials.
 *
 *   'Audra Hedberg' -> 'Audra H.'
 *   'E Oster'       -> 'E. O.'
 *   'MJB'           -> 'MJB'
 *   'Cher'          -> 'Cher'
 */
export function publicReviewerName(name: string | null | undefined): string {
  const parts = (name ?? '')
    .trim()
    .split(/\s+/)
    .map((p) => p.replace(/^[.,]+|[,]+$/g, ''))
    .filter(Boolean)
  if (parts.length === 0) return ''
  const initial = (p: string) => `${p.charAt(0).toUpperCase()}.`
  const isInitial = (p: string) => /^\p{L}\.?$/u.test(p)
  if (parts.length === 1) {
    const only = parts[0]!
    return isInitial(only) ? initial(only) : only
  }
  const first = parts[0]!
  const last = parts[parts.length - 1]!
  if (isInitial(first)) return `${initial(first)} ${initial(last)}`
  return `${first} ${initial(last)}`
}
